/**
 * TanStack Query hook for fetching Slide Sense decks for a folder.
 *
 * Decks-first folder view: cheap to fetch (one row per deck), and lets the
 * UI render the deck headers without touching slide data. Slides for each
 * deck load lazily via useSlides({ deckId }) when the section expands.
 */

import { useQuery } from "@tanstack/react-query"

import type { SlideSenseDeck } from "../types"

import { fetchDecks } from "../api"

export function useDecks(params: { folderId?: string }) {
  return useQuery<SlideSenseDeck[]>({
    queryKey: ["slide-sense", "decks", params.folderId ?? "all"],
    queryFn: () => fetchDecks({ folder_id: params.folderId }),
    staleTime: 30_000,
  })
}
